import { FilterMultiSelect } from "@/components/common/FilterMultiSelect";
import { useHotel } from "@/hooks/useHotel";
import { useHotelServices } from "@/hooks/useHotelServices";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export interface ServiceFilterProps {
  ids: string[];
  onChange: (ids: string[]) => void;
  placeholder?: string;
}

const ServiceFilter: React.FC<ServiceFilterProps> = ({
  ids,
  onChange,
  placeholder,
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string[]>(ids || []);

  const { hotelId } = useHotel();
  const { data: servicesData } = useHotelServices(hotelId!);

  const handleChange = (ids: string[]) => {
    setSelected(ids);
    onChange(ids);
  };

  return (
    <FilterMultiSelect
      className="w-[200px] justify-between"
      options={
        servicesData?.data
          ? servicesData.data.map((service) => ({
              value: service.id,
              label: `${service.name}`,
            }))
          : []
      }
      placeholder={
        placeholder ??
        t("feedbacks.filters.service", "Filter feedbacks by services")
      }
      value={selected}
      onValueChange={handleChange}
    />
  );
};

export default ServiceFilter;
